import { defineHotpadsEvent, trackHotpadsEventDefinition } from '../track';
import type { ListingArg } from './types';

export type PropertyMapSurface = 'home_details' | 'home_details_unit_modal';
export type PropertyMapInteraction =
  | 'filter_for_property_map_bed'
  | 'filter_for_property_map_floor'
  | 'button_to_zoom_property_map'
  | 'button_to_view_property_map_unit'
  | 'tab_to_open_property_map'
  | 'button_to_reset_property_map';

const PROPERTY_MAP_ENTRY = defineHotpadsEvent({
  key: 'hdp.property_map_entry',
  eventTypeId: '10252',
  eventTypeVersionId: '1',
  eventTemplateId: '4',
  eventTemplateVersionId: '1',
  trigger: {
    type: 'impression',
    location: 'home_details',
    source: 'property_map_entry',
    object: 'home_details_component|property_map',
  },
  semanticEvent: 'view_content',
});

const PROPERTY_MAP_VIEW = defineHotpadsEvent({
  ...PROPERTY_MAP_ENTRY,
  key: 'hdp.property_map_view',
  eventTypeId: '10253',
  trigger: { ...PROPERTY_MAP_ENTRY.trigger, source: 'property_map' },
});

const PROPERTY_MAP_INTERACTION = defineHotpadsEvent({
  ...PROPERTY_MAP_ENTRY,
  key: 'hdp.interact_property_map',
  eventTypeId: '10254',
  trigger: { ...PROPERTY_MAP_ENTRY.trigger, type: 'interaction' },
  semanticEvent: 'interact_property_map',
});

type PropertyMapEventArgs = ListingArg & { surface: PropertyMapSurface };

function propertyMapContext({ listing, surface }: PropertyMapEventArgs) {
  return {
    // Map attribution stays on the parent property when the selected unit changes.
    listing: listing ? { ...listing, units: undefined } : listing,
    triggerLocation: surface,
    triggerObject:
      surface === 'home_details_unit_modal'
        ? 'home_details_component|unit_modal|property_map'
        : 'home_details_component|property_map',
  };
}

export function emitTrackPropertyMapEntryEvent(args: PropertyMapEventArgs) {
  trackHotpadsEventDefinition(PROPERTY_MAP_ENTRY, propertyMapContext(args));
}

export function emitTrackPropertyMapViewEvent(args: PropertyMapEventArgs) {
  trackHotpadsEventDefinition(PROPERTY_MAP_VIEW, propertyMapContext(args));
}

export function emitTrackPropertyMapInteractionEvent(args: PropertyMapEventArgs & { source: PropertyMapInteraction }) {
  trackHotpadsEventDefinition(PROPERTY_MAP_INTERACTION, { ...propertyMapContext(args), triggerSource: args.source });
}
